// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionB1_comp__Afmqi"};